import OrderView from './OrderView';

export default OrderView;
